// Module
var code = `<form-section form-title="\$ctrl.incomeFormTitle">
  <form-section-field field-title="'Monthly income amount'"
                      ng-if="\$ctrl.cfg.visible('customer', 'income', 'annual_income')">
    <cash ng-required="\$ctrl.cfg.required('customer', 'income', 'annual_income')"
          ng-model="\$ctrl.monthlyIncome"
          ng-disabled="!\$ctrl.editMode""></cash>
  </form-section-field>
  <form-section-field field-title="'Annual income amount'"
                      ng-if="\$ctrl.cfg.visible('customer', 'income', 'annual_income')">
    <cash ng-required="\$ctrl.cfg.required('customer', 'income', 'annual_income')"
          ng-model="\$ctrl.sourceOfIncome.annualIncome"
          ng-disabled="!\$ctrl.editMode""></cash>
  </form-section-field>
  <form-section-field field-title="'Income source'" ng-if="\$ctrl.cfg.visible('customer', 'income', 'source')">
    <select type="text"
            ng-model="\$ctrl.sourceOfIncome.type"
            ng-disabled="true"
            ng-options="entry.code as entry.description for entry in \$ctrl.types">
      <option></option>
    </select>
  </form-section-field>
  <form-section-field field-title="'Primary'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'primary')">
    <select ng-model="\$ctrl.sourceOfIncome.primary"
            ng-class="{'non-valid-primary-income-source': !\$ctrl.hasOnePrimaryIncomeSource()}"
            ng-disabled="!\$ctrl.editMode"
            ng-change="\$ctrl.primaryIncomeSourceChanged(\$ctrl.sourceOfIncome, \$index)"
            boolean-options>
    </select>
  </form-section-field>
  <form-section-field field-title="'Employer type'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'employer_type')">
    <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'employer_type')"
            ng-model="\$ctrl.sourceOfIncome.employerType"
            ng-options="employerType | prettyEnum for employerType in \$ctrl.employerTypes">
      <option></option>
    </select>
  </form-section-field>
  <form-section-field field-title="'Region Code'">
    <input ng-required="true"
           type="text"
           ng-model="\$ctrl.sourceOfIncome.depEdRegionCode"
           ng-disabled="!\$ctrl.editMode"
           placeholder="Region Code"
           maxlength="3">
  </form-section-field>
  <form-section-field field-title="'Division Code'">
    <input ng-required="true"
           type="text"
           ng-model="\$ctrl.sourceOfIncome.depEdDivisionCode"
           ng-pattern="/^\\d{0,3}\$/"
           ng-disabled="!\$ctrl.editMode"
           placeholder="Division Code"
           maxlength="3">
  </form-section-field>
  <form-section-field field-title="'Station Code'">
    <input ng-required="true"
           type="text"
           ng-model="\$ctrl.sourceOfIncome.depEdStationCode"
           ng-pattern="/^\\d{0,3}\$/"
           ng-disabled="!\$ctrl.editMode"
           placeholder="Station Code"
           maxlength="3">
  </form-section-field>
  <form-section-field field-title="'Employee Number'">
    <input ng-required="true"
           type="text"
           ng-model="\$ctrl.sourceOfIncome.depEdEmployeeNumber"
           ng-pattern="/^\\d{0,7}\$/"
           ng-disabled="!\$ctrl.editMode"
           placeholder="Employee number"
           maxlength="7">
  </form-section-field>
</form-section>

<div ng-show="\$ctrl.editMode">
  <button ng-click="\$ctrl.removeIncomeSource(\$ctrl.sourceOfIncome)"
          class="btn btn-danger btn--align-with-form-field" type="button">
    Remove source of income
  </button>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/shared/customer-profile-commons/income-source/deped-income-source.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;